var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',[_c('Col',[_c('TimePicker',{staticStyle:{"width":"200px"},attrs:{"value":_vm.time,"placement":_vm.placement,"type":_vm.type,"format":_vm.format,"placeholder":_vm.placeholder},on:{"on-change":_vm.handleChange}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }